import React, { memo } from "react"

const Title = memo(({ content, type }) => {
  const styles = {
    title: {
      width: "100%",
      margin: "10px auto",
      fontWeight: "bold",
      color: "rgb(83, 152, 255)",
    },
    ht: {
      width: "100%",
      textAlign: "center",
      fontSize: "90%",
    },
    hs: {
      width: "100%",
      textAlign: "center",
      fontSize: "80%",
    },
  }
  return (
    <div style={{ ...styles[type], ...styles.title }}>
      {content.map((leaf, index) => (
        <span
          key={`Title-span-${index}-${type}`}
          style={type === "hs" ? { color: "black" } : {}}
        >
          {leaf.text}
        </span>
      ))}
    </div>
  )
})

export default Title
